<template>
    <div>
        <CRow class="mb-3">
            <CCol
                col="3"
                tag="label"
                class="col-form-label">Подписанты</CCol>
            <CCol col="9" class="pl-2">
                <CRow
                    v-for="(slot, index) of signersSlots"
                    :key="index"
                    class="d-flex justify-content-start pl-1 pr-3"
                >
                    <CCol col="4">
                        <span>Должность</span>
                        <CInput
                            v-model="slot.position"
                            :change="$emit('set-signers', signersSlots)"
                        />
                    </CCol>
                    <CCol col="4">
                        <span>ФИО</span>
                        <CInput
                            v-model="slot.name"
                            :change="$emit('set-signers', signersSlots)"
                        />
                    </CCol>
                    <CCol col="3">
                        <span>Юр. лицо</span>
                        <CInput
                            v-model="slot.legal_entity"
                            :change="$emit('set-signers', signersSlots)"
                        />
                    </CCol>
                    <CCol col="1" class="d-flex align-items-center justify-content-center">
                        <CButton
                            shape="pill"
                            color="danger"
                            variant="ghost"
                            @click="removeSlot(index)"
                        >
                            <CIcon
                                :height="24"
                                :content="$options.icons.cilTrash"
                                class="handle"
                            />
                            Удалить
                        </CButton>
                    </CCol>
                </CRow>
                <CButton
                    shape="pill"
                    color="success"
                    variant="ghost"
                    @click="addSlot"
                >
                    <CIcon
                        :height="24"
                        :content="$options.icons.cilPlus"
                        class="handle"
                    />
                    Добавить
                </CButton>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import { cilPlus, cilTrash } from '@coreui/icons';
    export default {
        icons: {
            cilPlus,
            cilTrash
        },

        props: {
            signers: {
                type: Array,
                default: () => [],
            },
        },

        data: () => ({
            signersSlots: [],
        }),

        watch: {
            signers: function() {
                this.setModel();
            }
        },

        created() {
            this.setModel();
        },

        methods: {
            setModel() {
                this.signersSlots = this.signers;
            },
            addSlot() {
                this.signersSlots.push({
                    position: 'Директор',
                    name: 'Фамилия И.О.',
                    legal_entity: 'ООО',
                });
                this.$emit('set-signers', this.signersSlots);
            },
            removeSlot(ind) {
                this.signersSlots.splice(ind, 1);
                this.$emit('set-signers', this.signersSlots);
            }
        },
    };
</script>
